import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SharedConfig, SHARED_CONFIG, Subscription } from '@emi/shared/models';

@Injectable({
  providedIn: 'root',
})
export class SubscriberService {

  private baseURL = '';

  constructor(@Inject(SHARED_CONFIG) private config: SharedConfig, private httpclient: HttpClient) {
    this.baseURL = config.subscriberServiceUrl;
  }

  public getSubscriptions(
    userId: string,
    accessToken: string
  ): Observable<Subscription[]> {
    const headers = new HttpHeaders().set(
      'Authorization',
      'Bearer ' + accessToken
    );
    return this.httpclient.get<Subscription[]>(
      this.baseURL + '/subscribers/associated-with/' + userId,
      { headers: headers }
    );
  }

  public getSubscriberJwt(
    subscriberId: string,
    accessToken: string
  ): Observable<string> {

    const headers = new HttpHeaders()
      .set('Authorization', 'Bearer ' + accessToken,)
      .set('Accept', 'application/json, text/plain, */*');

    return this.httpclient.get<string>(
      this.baseURL + '/subscribers/jwt?subscriberId=' + subscriberId,
      { headers: headers }
    );
  }

  public getSubscriptionById(
    accessToken: string,
    subscriberId: string
  ): Observable<Subscription> {

    const headers = new HttpHeaders()
      .set('Authorization', 'Bearer ' + accessToken,)
      .set('Accept', 'application/json, text/plain, */*');

    return this.httpclient.get<Subscription>(
      this.baseURL + '/subscribers/' + subscriberId,
      { headers: headers }
    );
  }
}
